<template>
    <span :class="timeClass">
        {{ date.format('h:mm a') }}
    </span>
</template>

<script>
    export default {
        props: {
            date: { type: Object, required: true },
            hasUnderline: { type: Boolean, default: false },
        },

        computed: {
            timeClass() {
                return {
                    time: true,
                    'time--has-underline': this.hasUnderline,
                }
            },
        },
    }
</script>
